import cn from './cn';
import en from './en';
import it from './it';
export default {
    cn:cn,
    en:en,
    it:it
}